import { render, staticRenderFns } from "./button-tab.vue?vue&type=template&id=69fcfa03&scoped=true&lang=pug&"
import script from "./button-tab.vue?vue&type=script&lang=js&"
export * from "./button-tab.vue?vue&type=script&lang=js&"
import style0 from "./button-tab.vue?vue&type=style&index=0&id=69fcfa03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fcfa03",
  null
  
)

export default component.exports